import { render, staticRenderFns } from "./ButtonsAddCompany.vue?vue&type=template&id=40019852&scoped=true&"
import script from "./ButtonsAddCompany.vue?vue&type=script&lang=js&"
export * from "./ButtonsAddCompany.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsAddCompany.vue?vue&type=style&index=0&id=40019852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40019852",
  null
  
)

export default component.exports